import { render, staticRenderFns } from "./educationList.vue?vue&type=template&id=2644e0bd"
import script from "./educationList.vue?vue&type=script&lang=js"
export * from "./educationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2644e0bd')) {
      api.createRecord('2644e0bd', component.options)
    } else {
      api.reload('2644e0bd', component.options)
    }
    module.hot.accept("./educationList.vue?vue&type=template&id=2644e0bd", function () {
      api.rerender('2644e0bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/school/educationList.vue"
export default component.exports